<mat-grid-list cols="4" rowHeight="100px">
  <mat-grid-tile *ngFor="let tile of tiles" [colspan]="tile.cols" [rowspan]="tile.rows" class="property-information-first-grid-row">
    <div class="full-width-height">
      <ng-container [ngSwitch]="tile.text">
        <img *ngSwitchCase="'Photo 1'" src="assets/images/others/prop1.jpg" alt="Photo 1">
        <img *ngSwitchCase="'Photo 4'" src="assets/images/others/Kitchen.jpg" alt="Photo 4">
        <img *ngSwitchCase="'Map'" src="assets/images/others/stats.jpg" alt="Map">
        <app-property-stats *ngSwitchCase="'Stats'"></app-property-stats>
        <img *ngSwitchCase="'Photo 2'" src="assets/images/others/prop1.jpg" alt="Photo 2">
        <img *ngSwitchCase="'Photo 3'" src="assets/images/others/prop1.jpg" alt="Photo 3">
      </ng-container>
    </div>
  </mat-grid-tile>
</mat-grid-list>
<mat-grid-list cols="6" rowHeight="125px">
  <mat-grid-tile *ngFor="let tile of tiles2" [colspan]="tile.cols" [rowspan]="tile.rows" [class.stepper-tile]="tile.text === 'Timeline'"
   class="property-information-second-grid-row">
    <div *ngIf="tile.text === 'Timeline'" class="full-width-height">
      <mat-vertical-stepper class="stepper-tile">
        <mat-step label="Key Events 1">
          <p>Details of Event 1...</p>
        </mat-step>
        <mat-step label="Key Event 2">
          <p>Details of Event 2...</p>
        </mat-step>
        <mat-step label="Leased Apr 2022">
          <p>Details of Event 3...</p>
        </mat-step>
      </mat-vertical-stepper>
    </div>
    <div *ngIf="tile.text === 'Information'" class="full-width-height form-container">
      <form fxLayout="row" fxLayoutGap="20px" fxLayoutAlign="space-around center">
        <mat-form-field appearance="outline" fxFlex="45%">
          <mat-label>Property Type</mat-label>
          <mat-select placeholder="Select Property type">
            <mat-option value="residential">Residential</mat-option>
            <mat-option value="commercial">Commercial</mat-option>
            <mat-option value="industrial">Industrial</mat-option>
            <!-- Additional options -->
          </mat-select>
        </mat-form-field>
        <mat-form-field appearance="outline" fxFlex="45%">
          <mat-label>County</mat-label>
          <mat-select placeholder="Select Property type">
            <mat-option value="residential">Residential</mat-option>
            <mat-option value="commercial">Commercial</mat-option>
            <mat-option value="industrial">Industrial</mat-option>
            <!-- Additional options -->
          </mat-select>
        </mat-form-field>
        <mat-form-field appearance="outline" fxFlex="45%">
          <mat-label>Property Subtype</mat-label>
          <mat-select placeholder="Select Property type">
            <mat-option value="residential">Residential</mat-option>
            <mat-option value="commercial">Commercial</mat-option>
            <mat-option value="industrial">Industrial</mat-option>
            <!-- Additional options -->
          </mat-select>
        </mat-form-field>
        <mat-form-field appearance="outline" fxFlex="45%">
          <mat-label>Region</mat-label>
          <mat-select placeholder="Select Property type">
            <mat-option value="residential">Residential</mat-option>
            <mat-option value="commercial">Commercial</mat-option>
            <mat-option value="industrial">Industrial</mat-option>
            <!-- Additional options -->
          </mat-select>
        </mat-form-field>
        <mat-form-field appearance="outline" fxFlex="45%">
          <mat-label>Classification</mat-label>
          <mat-select placeholder="Select Property type">
            <mat-option value="residential">Residential</mat-option>
            <mat-option value="commercial">Commercial</mat-option>
            <mat-option value="industrial">Industrial</mat-option>
            <!-- Additional options -->
          </mat-select>
        </mat-form-field>
        <mat-form-field appearance="outline" fxFlex="45%">
          <mat-label>MSA</mat-label>
          <mat-select placeholder="Select Property type">
            <mat-option value="residential">Residential</mat-option>
            <mat-option value="commercial">Commercial</mat-option>
            <mat-option value="industrial">Industrial</mat-option>
            <!-- Additional options -->
          </mat-select>
        </mat-form-field>
        <mat-form-field appearance="outline" fxFlex="45%">
          <mat-label>Latitude</mat-label>
          <mat-select placeholder="Select Property type">
            <mat-option value="residential">Residential</mat-option>
            <mat-option value="commercial">Commercial</mat-option>
            <mat-option value="industrial">Industrial</mat-option>
            <!-- Additional options -->
          </mat-select>
        </mat-form-field>
        <mat-form-field appearance="outline" fxFlex="45%">
          <mat-label>Market</mat-label>
          <mat-select placeholder="Select Property type">
            <mat-option value="residential">Residential</mat-option>
            <mat-option value="commercial">Commercial</mat-option>
            <mat-option value="industrial">Industrial</mat-option>
            <!-- Additional options -->
          </mat-select>
        </mat-form-field>
        <mat-form-field appearance="outline" fxFlex="45%">
          <mat-label>Longitude</mat-label>
          <mat-select placeholder="Select Property type">
            <mat-option value="residential">Residential</mat-option>
            <mat-option value="commercial">Commercial</mat-option>
            <mat-option value="industrial">Industrial</mat-option>
            <!-- Additional options -->
          </mat-select>
        </mat-form-field>
        <mat-form-field appearance="outline" fxFlex="45%">
          <mat-label>Submarket</mat-label>
          <mat-select placeholder="Select Property type">
            <mat-option value="residential">Residential</mat-option>
            <mat-option value="commercial">Commercial</mat-option>
            <mat-option value="industrial">Industrial</mat-option>
            <!-- Additional options -->
          </mat-select>
        </mat-form-field>
        <mat-form-field appearance="outline" fxFlex="45%">
          <mat-label>Location</mat-label>
          <mat-select placeholder="Select Property type">
            <mat-option value="residential">Residential</mat-option>
            <mat-option value="commercial">Commercial</mat-option>
            <mat-option value="industrial">Industrial</mat-option>
            <!-- Additional options -->
          </mat-select>
        </mat-form-field>
        <mat-form-field appearance="outline" fxFlex="45%">
          <mat-label>Tenancy</mat-label>
          <mat-select placeholder="Select Property type">
            <mat-option value="residential">Residential</mat-option>
            <mat-option value="commercial">Commercial</mat-option>
            <mat-option value="industrial">Industrial</mat-option>
            <!-- Additional options -->
          </mat-select>
        </mat-form-field>
        <mat-slide-toggle style="margin-left: 14%;">Condominium</mat-slide-toggle>
      </form>
    </div>
    <div *ngIf="tile.text !== 'Timeline' && tile.text !== 'Information'">
      {{ tile.text }}
    </div>
  </mat-grid-tile>
</mat-grid-list>
